import React from "react";

export default function Impact() {
  const ImpactMetric = ({ title, description, iconSrc }) => (
    <div className="flex flex-col items-center text-center p-4 py-8"> 
      <div className="w-16 h-16 mb-4 rounded-full flex items-center justify-center">
        <img
          src={iconSrc}
          alt={`${title} icon`}
          className="w-full h-full object-contain"
        />
      </div>
      
      <p className="text-[20px] font-bold mb-2 font-custom-uber">
        {title}
      </p>
      
      <p 
        className="
          text-gray-300 max-w-xs
          font-custom-uber text-base font-normal leading-normal
        "
      >
        {description}
      </p>
    </div>
  );

  const VerticalDivider = () => (
    <div className="hidden md:block w-px bg-white self-stretch my-8"></div> 
  );
  
  const HorizontalDivider = () => (
    <div className="md:hidden w-3/4 h-px bg-white mx-auto"></div>
  );

  return (
    <section className="relative w-full overflow-hidden bg-black text-white">
      <div className="mx-auto max-w-6xl py-16 px-4 sm:px-4">
        
        <div className="text-center mb-12">
          <h1 
            className="
              w-full
              font-uber text-[28px] font-bold leading-[36px] text-current
              sm:text-[32px] sm:leading-[40px]
              xl-custom:text-[36px] xl-custom:leading-[44px]
              transition duration-200 ease-in-out
            "
          >
            Impact
          </h1>
        </div>
        
        <div className="flex flex-col md:flex-row justify-between items-stretch">
          
          <ImpactMetric
            title="Increased Engagement"
            description="Playables recorded a 3x increase in interaction time compared to traditional digital content."
            iconSrc="/uploads/CaseStudy/Asset 132.svg"
          />
          
          <HorizontalDivider />
          <VerticalDivider />
          
          <ImpactMetric
            title="Higher Conversion Rate"
            description="Users who engaged with playables were 1.5x more likely to take the desired action."
            iconSrc="/uploads/CaseStudy/Asset 133.svg"
          />
          
          <HorizontalDivider />
          <VerticalDivider />
          
          <ImpactMetric
            title="Entertainment Value"
            description="A significant boost in brand retention was observed, leading to improved long-term customer loyalty."
            iconSrc="/uploads/CaseStudy/Asset 134.svg"
          />
          
        </div>
      </div>
    </section>
  );
}